import Session from "supertokens-web-js/recipe/session";
import { reactive } from "vue";

export const UserStorageService = reactive({
    user: {
        name: '' as string,
        id: '' as string,
        postalCode: '' as string
    },
    setUserData(newData: {name:string, id:string, postalCode:string}) {
        this.user = newData;
    },
    clearUserData() {
        this.user.id=''; 
        this.user.name=''; 
    }
});

export const UserService = {
    getUserId() : Promise<string> {
        return Session.getUserId();
    }
}